<div class="w-5 h-5">
  <img
    ngSrc="img/logo/logo-light.png"
    alt="smallsalon logo"
    width="140"
    height="140"
    class="w-full h-auto rounded block dark:hidden"
  />
  <img
    ngSrc="img/logo/logo-dark.png"
    alt="smallsalon logo"
    width="140"
    height="140"
    class="w-full h-auto rounded hidden dark:block"
  />
</div>
